"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'pagesHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    backUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack: function goBack() {
      if (this.backUrl) {
        this.$router.push({
          path: this.backUrl
        });
      } else {
        this.$router.back();
      }
    }
  }
};